import {
  FETCH_BOOKING_LOCATION,
  FETCH_BOOKING_LOCATION_SUCCESS,
  FETCH_BOOKING_LOCATION_FAILED,
  STOP_LOCATION_FETCH,
} from "../store/types";
import store from "../store/store";
import { firebase } from "../config/configureFirebase";
import { query, onValue, set, off, push, limitToLast } from "firebase/database";

export const saveTracking = (bookingId, location) => {
  // console.log("💾 saveTracking called:", { bookingId, location }); // Removed repetitive log
  // console.log("💾 Current timestamp:", new Date().toISOString()); // Removed repetitive log

  const { trackingRef } = firebase;

  if (!trackingRef) {
    console.error("❌ trackingRef not available in Firebase config");
    return;
  }

  if (!bookingId || !location || !location.lat || !location.lng) {
    console.error("❌ Invalid parameters for saveTracking:", {
      bookingId,
      location,
    });
    console.error("❌ Details - bookingId:", bookingId);
    console.error("❌ Details - location:", location);
    return;
  }

  // console.log("🔄 Attempting to save to path: tracking/" + bookingId); // Removed repetitive log
  // console.log("🔄 Location data to save:", JSON.stringify(location, null, 2)); // Removed repetitive log

  try {
    const result = push(trackingRef(bookingId), location);
    // console.log("✅ Location saved to Firebase tracking with key:", result.key); // Removed repetitive log
    // console.log("✅ Full Firebase reference:", result.toString()); // Removed repetitive log
    return result;
  } catch (error) {
    console.error("❌ Error saving tracking location:", error);
    console.error("❌ Error details:", error.message);
    console.error("❌ Error stack:", error.stack);
  }
};

// Manual debug function to check tracking data via console
export const debugCheckTracking = async (bookingId) => {
  console.log("🔍 [MANUAL DEBUG] Checking tracking for:", bookingId);
  const { trackingRef } = firebase;

  // Import get function
  const { get } = await import("firebase/database");

  try {
    const snapshot = await get(trackingRef(bookingId));
    console.log("🔍 [MANUAL DEBUG] Data exists:", snapshot.exists());
    if (snapshot.exists()) {
      console.log("🔍 [MANUAL DEBUG] Data:", snapshot.val().length);
    } else {
      console.log(
        "🔍 [MANUAL DEBUG] No data found at path: tracking/" + bookingId
      );
    }
  } catch (error) {
    console.error("🔍 [MANUAL DEBUG] Error:", error);
  }
};

export const fetchBookingLocations = (bookingId) => (dispatch) => {
  const { trackingRef } = firebase;

  if (!trackingRef) {
    console.error("❌ trackingRef is not available in firebase config");
    dispatch({
      type: FETCH_BOOKING_LOCATION_FAILED,
      payload: "Firebase tracking reference not available",
    });
    return;
  }

  dispatch({
    type: FETCH_BOOKING_LOCATION,
    payload: bookingId,
  });

  // Production optimized: Removed debug logging for performance

  onValue(
    query(trackingRef(bookingId), limitToLast(1)),
    (snapshot) => {
      // Performance optimized: Removed debug logging
      if (snapshot.val()) {
        let data = snapshot.val();
        // console.log("📍 Raw tracking data:", data); // Removed repetitive log

        const locations = Object.keys(data).map((i) => {
          return data[i];
        });

        // console.log("📍 Processed locations array:", locations); // Removed repetitive log
        // console.log("📍 Locations length:", locations.length); // Removed repetitive log

        if (locations.length == 1) {
          const locationData = locations[locations.length - 1];
          // console.log("✅ Dispatching FETCH_BOOKING_LOCATION_SUCCESS with:", locationData); // Removed repetitive log

          dispatch({
            type: FETCH_BOOKING_LOCATION_SUCCESS,
            payload: locationData,
          });
        } else {
          console.log("⚠️ Unexpected locations length:", locations.length);
          dispatch({
            type: FETCH_BOOKING_LOCATION_FAILED,
            payload:
              store.getState().languagedata.defaultLanguage
                .location_fetch_error,
          });
        }
      } else {
        console.log("❌ No tracking data found for booking:", bookingId);
        dispatch({
          type: FETCH_BOOKING_LOCATION_FAILED,
          payload:
            store.getState().languagedata.defaultLanguage.location_fetch_error,
        });
      }
    },
    (error) => {
      console.error("❌ Firebase listener error:", error);
      dispatch({
        type: FETCH_BOOKING_LOCATION_FAILED,
        payload: error.message || "Firebase listener error",
      });
    }
  );
};

export const stopLocationFetch = (bookingId) => (dispatch) => {
  const { trackingRef } = firebase;

  dispatch({
    type: STOP_LOCATION_FETCH,
    payload: bookingId,
  });
  off(trackingRef(bookingId));
};

export const saveUserLocation = (location) => {
  const { auth, userLocationRef } = firebase;
  const uid = auth.currentUser.uid;
  set(userLocationRef(uid), location);
};
